export var LIQUIDATION_VOLUME_RANGES = [
    { name: 'Week', value: 'weekly' },
    { name: 'Month', value: 'monthly' }
];
